<template>
  <div
    class="visaItems-wrap"
    :class="getCurThemeType == 'enWrap' ? 'enWrap-font-wrap' : ''"
  >
    <div class="page1-wrap page-same">
      <!-- <div class="title1">{{$t('products.navTitle12')}}</div>
        <div class="title2">{{$t('products.navTitle13')}}</div> -->
    </div>
    <div class="page2-wrap page-same">
      <div class="w">
        <div class="title">{{ $t("home.homeTilte6") }}</div>
      </div>
    </div>
    <div
      class="page3-wrap page-same"
      :class="'same' + index"
      v-for="(item, index) in pageList"
      :key="index"
    >
      <div class="w">
        <!-- 整体 -->
        <div class="content-box">
          <!-- 头部 -->
          <div class="hander-wrap">
            <div class="pic">
              <img :src="item.pic" alt="" />
            </div>
            <div class="top-right-wrap">
              <div class="label-wrap">
                <div
                  class="item-l"
                  v-html="$t('visaItems.' + item.lable)"
                ></div>
                <div v-if="item.lable" class="item-r">
                  <div
                    v-for="(val, index) in item.pdf"
                    :key="index"
                    @click="handePdf(val.value)"
                  >
                    <span
                      >{{ $t("visaItems." + val.text) }}
                      <i class="iconfont icon-Fill1"></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="directory-wrap">
            <div
              class="directory-list"
              v-for="(item2, index2) in item.projectOne"
              :key="index2"
            >
              <div>
                <div class="title">{{ $t("visaItems." + item2.title) }}</div>
                <ul class="ul-wrap">
                  <li v-for="(item3, index3) in item2.child" :key="index3">
                    <div
                      v-if="
                        item3 == 'list2Text8_1' ||
                          item3 == 'list2Text8_2' ||
                          item3 == 'list2Text8_3'
                      "
                      style="transform: translateX(0px);"
                    >
                      <i></i><span v-html="$t('visaItems.' + item3)"></span>
                    </div>
                    <div v-else style="transform: translateX(-20px);">
                      <i></i><span v-html="$t('visaItems.' + item3)"></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "services",
  metaInfo: {
    title: "KrngPartners", // set a title
    meta: [
      {
        // set meta
        name: "",
        content: "",
      },
      {
        name: "",
        content: "",
      },
    ],
  },
  data() {
    return {
      pageList: [
        {
          lable: "Label1",
          pic: require("../../assets/img/visaItems/page1.png"),
          pdf: [{ value: "0", text: "checklist" }],
          projectOne: [
            {
              title: "list1Title1",
              child: [
                "list1Text1",
                "list1Text2",
                "list1Text3",
                "list1Text4",
                "list1Text5",
                "list1Text6",
                "list1Text7",
                "list1Text8",
                "list1Text9",
              ],
            },
          ],
        },
        {
          lable: "Label2",
          pic: require("../../assets/img/visaItems/page2.png"),
          pdf: [{ value: "0", text: "checklist" }],
          projectOne: [
            {
              title: "list2Title1",
              child: [
                "list2Text1",
                "list2Text2",
                "list2Text3",
                "list2Text4",
                "list2Text5",
                "list2Text6",
                "list2Text7",
                "list2Text8",
                "list2Text8_1",
                "list2Text8_2",
                "list2Text8_3",
                "list2Text9",
                "list2Text10",
              ],
            },
          ],
        },
        {
          lable: "Label3",
          pic: require("../../assets/img/visaItems/page3.png"),
          pdf: [{ value: "1", text: "checklist" }],
          projectOne: [
            {
              title: "list3Title1",
              child: [
                "list3Text1",
                "list3Text2",
                "list3Text3",
                "list3Text4",
                "list3Text5",
                "list3Text6",
                "list3Text7",
                "list3Text8",
                "list3Text9",
                "list3Text10",
                "list3Text11",
              ],
            },
          ],
        },
        {
          lable: "Label4",
          pic: require("../../assets/img/visaItems/page5.png"),
          pdf: [
            { value: "2", text: "checklistA" },
            { value: "3", text: "checklistB" },
            { value: "4", text: "checklistC" },
          ],
          projectOne: [
            {
              title: "list4Title1",
              child: [
                "list4Text1",
                "list4Text2",
                "list4Text3",
                "list4Text4",
                "list4Text5",
                "list4Text6",
                "list4Text7",
                "list4Text8",
                "list4Text9",
                "list4Text10",
                "list4Text11",
                "list4Text12",
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {},
  components: {},
  created() {},

  methods: {
    handePdf(index) {
      let arr = ["188ab", "188c", "888a", "888b", "888c"];
      window.open(
        `http://www.giant-partners.com/pdf/${arr[index]}.pdf`,
        "_self"
      );
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "visaItems.scss";
</style>
